import Head from "next/head";

export interface HeadProps {
  metadescription?: string;
  title?: string;
  viewport?: string;
  disableCrawl?: boolean;
  openGraph?: {
    url?: string;
    image?: string;
  };
}

const defaults = {
  metadescription: "",
  title: "Sourceful",
  viewport: "initial-scale=1.0, width=device-width",
  siteName: "Sourceful",
  image: "/opengraph-fallback.png",
  url: "https://shop.sourceful.com",
};

const StandardHead = ({
  metadescription,
  title,
  viewport,
  openGraph,
  disableCrawl = false,
}: HeadProps) => {
  const { image, url } = {
    image: openGraph?.image || defaults.image,
    url: openGraph?.url || defaults.url,
  };
  return (
    <Head>
      <title key="title">{title ? title + " | Sourceful" : defaults.title}</title>
      <meta name="viewport" content={viewport ?? defaults.viewport} />
      <meta name="description" content={metadescription ?? defaults.metadescription} />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta
        name="twitter:card"
        content={metadescription ?? defaults.metadescription}
        key="twcard"
      />
      <meta property="og:site_name" content={defaults.siteName} key="ogsitename" />

      {disableCrawl && <meta name="robots" content="noindex,nofollow"></meta>}
      <meta property="og:title" content={title ?? defaults.title} key="ogtitle" />
      <meta
        property="og:description"
        content={metadescription ?? defaults.metadescription}
        key="ogdescription"
      />
      <meta property="og:type" content="website" key="ogtype" />
      <meta property="og:image" content={image} key="ogimage" />
      <meta property="og:url" content={url} key="ogurl" />
    </Head>
  );
};

export default StandardHead;
